import { forwardRef, type InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'style' | 'className'> & { value: string };

/**
 * An input exactly as wide as what it shows — its text, or its placeholder
 * when empty — so a field reads like the canvas's typed text: "76 ✎",
 * "82 kg ✎", "120 / 80▌", with one space and no gap before the pencil.
 *
 * A hidden mirror of the text sizes an inline grid cell, and the input fills
 * the same cell. A `ch`-based width cannot do this: digits, dots and letters
 * are not one `ch` wide in a proportional face.
 */
export const FitInput = forwardRef<HTMLInputElement, Props>(function FitInput({ value, placeholder, ...rest }, ref) {
  return (
    <span className="nurse-fit">
      {/* An empty mirror still carries a zero-width space: with no text the
          cell has no baseline, and the grid would sit on its bottom edge and
          push the line down. */}
      <span aria-hidden className="nurse-fit-mirror">{value || placeholder || '\u200b'}</span>
      <input ref={ref} value={value} placeholder={placeholder} {...rest} />
    </span>
  );
});
